import { render, staticRenderFns } from "./PecasForm.vue?vue&type=template&id=9e6f68e2&scoped=true&"
import script from "./PecasForm.vue?vue&type=script&lang=js&"
export * from "./PecasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6f68e2",
  null
  
)

export default component.exports